export enum CertificateTypeLookupValue {
  IntraLic = 'Intra Lic',
  Dot = 'DOT',
  Fmc = 'FMC',
  Blic = 'BLIC'
}
